import { connect } from "react-redux";

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var CurrentUser = require("lib/account/CurrentUser");
var Features = require("lib/account/Features")
var UIActions = require("lib/actions/UIActions");
var ReadingLevelFormatPreference = require("components/users/teachers/preferences/ReadingLevelFormatPreference");
var PaywallModal = require("components/users/teachers/PaywallModal");

@connect(
	(state, props) => {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {}
		var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
		var hasDifferentiation = Features.isEnabled(Features.STUDENT_DIFFERENTIATION);

		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}

		return {
			automaticZPDExclude: prefs.automatic_zpd_exclusion,
			showStudentsZPDIcon: prefs.show_students_zpd_icon,
			hasDifferentiation
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['user.prefs'],
                cache: true
            }))])
        },
		onChange: (prefsUpdate, message) => {
			
			// RESETING ALL STUDENT LISTS
			var resetStudentLists = false

			if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.ass-specific setting previously selected.") == true) {
				resetStudentLists = true
			} 

			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch( RosterActions.updateAdminPrefs({
				id: CurrentUser.get().id,
				resetStudentLists: resetStudentLists,
				update: prefsUpdate
			}))
		},
		showZPDReadingLevelsPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.ZPD_READING_LEVELS }))

	})
)

class ZPDPreferences extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.myRef = React.createRef();
		LuckyOrangeClient.tagComponent("ZPDPreferences");
	}

	onOptionChange(which) {
		if (!this.props.hasDifferentiation) {
			this.props.showZPDReadingLevelsPaywall()
		} else {
			if (which == "optionOne") {
				var prefsHash = { automatic_zpd_exclusion: true, show_students_zpd_icon: true };
			} else if (which == "optionTwo") {
				var prefsHash = { automatic_zpd_exclusion: false, show_students_zpd_icon: true };
			} else if (which == "optionThree") {
				var prefsHash = { automatic_zpd_exclusion: false, show_students_zpd_icon: false };
			}

			this.props.onChange(prefsHash, "You successfully changed the ZPD setting.");
		}
	}

	componentDidMount() {
		var scrollToRLD = $wr.getURLParameterByName("showRLD");
		if (scrollToRLD) {
			const section = document.querySelector( '.rld' );
			section.scrollIntoView( { behavior: 'smooth', block: 'start' } );
		}
	}

	render() {
		var readingLevelFormatSelector = (
			<ReadingLevelFormatPreference onChange={ this.props.onChange }/>
		);
		return (
			<div>
				{ readingLevelFormatSelector }
				<div className="subContainer">
					<p className="subTitle">ZPD</p>
					<p>
						Control whether books below students’ reading levels count toward your goals.
					</p>
					<label>
						<input type="radio" onChange={ this.onOptionChange.bind(this, "optionOne") }
							checked={ this.props.automaticZPDExclude && this.props.showStudentsZPDIcon } />
						Exclude & Show ZPD Icons
						<p>Don't count books below a student's reading level toward goals. Students can see if books are below, at, or above their reading level.</p>
					</label><br />
					<label>
						<input type="radio" onChange={ this.onOptionChange.bind(this, "optionTwo") }
							checked={ !this.props.automaticZPDExclude && this.props.showStudentsZPDIcon } />
						Don't Exclude & Show ZPD Icons 
						<p>Count books of any reading level toward goals but show students if books are below, at, or above their reading level.</p>
					</label>
					<label>
						<input type="radio" onChange={ this.onOptionChange.bind(this, "optionThree") }
							checked={ !this.props.automaticZPDExclude && !this.props.showStudentsZPDIcon } />
						Don't Exclude & Don't show ZPD Icons
						<p>Allow books of any reading level to count toward goals and do not show students if books are below, at, or above their reading level.</p>	
					</label>
				</div>
			</div>
		)
	}
}

module.exports = ZPDPreferences;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/ZPDPreferences.js